import type { LearningExercise, SourceRef } from "../types";
import { makeCloze, makeFlashcard, makeMulti, makeOrdering, makeSingle } from "./legalExerciseFactory";

const sources: Record<string, SourceRef> = {
  patanw40: { id: "patanw40", label: "§ 40 PatAnwAPrV", url: "https://www.gesetze-im-internet.de/patanwaprv/__40.html" },
  dpmaAusbildung: { id: "dpmaAusbildung", label: "DPMA Patentanwaltsausbildung", url: "https://www.dpma.de/dpma/wir_ueber_uns/weitere_aufgaben/patentanwaltsausbildung/index.html" },
  bpatgAusbildung: { id: "bpatgAusbildung", label: "BPatG Patentanwaltsausbildung", url: "https://www.bundespatentgericht.de/DE/Karriere/Patentanwaltsausbildung/patentanwaltsausbildung_node.html" },
  patg12: { id: "patg12", label: "§ 12 PatG", url: "https://www.gesetze-im-internet.de/patg/__12.html" },
  patg21: { id: "patg21", label: "§ 21 PatG", url: "https://www.gesetze-im-internet.de/patg/__21.html" },
  patg24: { id: "patg24", label: "§ 24 PatG", url: "https://www.gesetze-im-internet.de/patg/__24.html" },
  patg44: { id: "patg44", label: "§ 44 PatG", url: "https://www.gesetze-im-internet.de/patg/__44.html" },
  patg59: { id: "patg59", label: "§ 59 PatG", url: "https://www.gesetze-im-internet.de/patg/__59.html" },
  patg61: { id: "patg61", label: "§ 61 PatG", url: "https://www.gesetze-im-internet.de/patg/__61.html" },
  patg64: { id: "patg64", label: "§ 64 PatG", url: "https://www.gesetze-im-internet.de/patg/__64.html" },
  patg81: { id: "patg81", label: "§ 81 PatG", url: "https://www.gesetze-im-internet.de/patg/__81.html" },
  patg123: { id: "patg123", label: "§ 123 PatG", url: "https://www.gesetze-im-internet.de/patg/__123.html" },
  gebrmg1: { id: "gebrmg1", label: "§ 1 GebrMG", url: "https://www.gesetze-im-internet.de/gebrmg/__1.html" },
  gebrmg2: { id: "gebrmg2", label: "§ 2 GebrMG", url: "https://www.gesetze-im-internet.de/gebrmg/__2.html" },
  gebrmg3: { id: "gebrmg3", label: "§ 3 GebrMG", url: "https://www.gesetze-im-internet.de/gebrmg/__3.html" },
  gebrmg5: { id: "gebrmg5", label: "§ 5 GebrMG", url: "https://www.gesetze-im-internet.de/gebrmg/__5.html" },
  gebrmg15: { id: "gebrmg15", label: "§ 15 GebrMG", url: "https://www.gesetze-im-internet.de/gebrmg/__15.html" },
  design2: { id: "design2", label: "§ 2 DesignG", url: "https://www.gesetze-im-internet.de/geschmmg/__2.html" },
  design3: { id: "design3", label: "§ 3 DesignG", url: "https://www.gesetze-im-internet.de/geschmmg/__3.html" },
  design27: { id: "design27", label: "§ 27 DesignG", url: "https://www.gesetze-im-internet.de/geschmmg/__27.html" },
  ggv: { id: "ggv", label: "VO (EG) Nr. 6/2002", url: "https://eur-lex.europa.eu/legal-content/DE/TXT/?uri=CELEX:32002R0006" },
  arb4: { id: "arb4", label: "§ 4 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__4.html" },
  arb5: { id: "arb5", label: "§ 5 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__5.html" },
  arb6: { id: "arb6", label: "§ 6 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__6.html" },
  arb9: { id: "arb9", label: "§ 9 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__9.html" },
  arb18: { id: "arb18", label: "§ 18 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__18.html" },
  arb28: { id: "arb28", label: "§ 28 ArbnErfG", url: "https://www.gesetze-im-internet.de/arbnerfg/__28.html" },
  sortschg: { id: "sortschg", label: "SortSchG", url: "https://www.gesetze-im-internet.de/sortschg_1985/" },
  halblschg: { id: "halblschg", label: "HalblSchG", url: "https://www.gesetze-im-internet.de/halblschg/" },
  marken42: { id: "marken42", label: "§ 42 MarkenG", url: "https://www.gesetze-im-internet.de/markeng/__42.html" },
  marken49: { id: "marken49", label: "§ 49 MarkenG", url: "https://www.gesetze-im-internet.de/markeng/__49.html" },
  madrid: { id: "madrid", label: "Madrider System (WIPO)", url: "https://www.wipo.int/madrid/en/" },
  agrar: { id: "agrar", label: "AgrargeoschutzDG", url: "https://www.gesetze-im-internet.de/agrargeoschutzdg/" },
  pao3: { id: "pao3", label: "§ 3 PAO", url: "https://www.gesetze-im-internet.de/patanwo/__3.html" },
  pao5: { id: "pao5", label: "§ 5 PAO", url: "https://www.gesetze-im-internet.de/patanwo/__5.html" },
  pao26: { id: "pao26", label: "§ 26 PAO", url: "https://www.gesetze-im-internet.de/patanwo/__26.html" },
  pao39a: { id: "pao39a", label: "§ 39a PAO", url: "https://www.gesetze-im-internet.de/patanwo/__39a.html" },
  pao54: { id: "pao54", label: "§ 54 PAO", url: "https://www.gesetze-im-internet.de/patanwo/__54.html" },
  zpo935: { id: "zpo935", label: "§§ 935 ff. ZPO", url: "https://www.gesetze-im-internet.de/zpo/__935.html" },
  zpo890: { id: "zpo890", label: "§ 890 ZPO", url: "https://www.gesetze-im-internet.de/zpo/__890.html" },
  uwg4: { id: "uwg4", label: "§ 4 UWG", url: "https://www.gesetze-im-internet.de/uwg_2004/__4.html" },
  pct22: { id: "pct22", label: "Art. 22 PCT", url: "https://www.wipo.int/pct/en/texts/articles/a22.html" },
  epc64: { id: "epc64", label: "Art. 64 EPÜ", url: "https://www.epo.org/en/legal/epc/2020/a64.html" },
  epc159: { id: "epc159", label: "R. 159 EPÜ", url: "https://www.epo.org/en/legal/epc/2020/r159.html" },
  intpat: { id: "intpat", label: "IntPatÜG", url: "https://www.gesetze-im-internet.de/intpat_g/" },
  upc: { id: "upc", label: "EPGÜ / UPC", url: "https://www.unified-patent-court.org/en/court/legal-framework" },
  pvue: { id: "pvue", label: "Pariser Verbandsübereinkunft", url: "https://www.wipo.int/wipolex/en/text/287556" },
  trips: { id: "trips", label: "TRIPS", url: "https://www.wto.org/english/docs_e/legal_e/27-trips.pdf" },
};

const pathId = "deutsche-ausbildung" as const;

export const ausbildungVollabdeckung: LearningExercise[] = [
  makeMulti(sources, {
    id: "da-core-001",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Pruefungsstruktur - § 40 PatAnwAPrV",
    title: "Schriftliche Pruefung: drei Aufgabentypen",
    prompt: "Welche Aufgabentypen nennt § 40 Abs. 1 PatAnwAPrV als Schwerpunkte der schriftlichen Patentanwaltspruefung?",
    options: [
      "Juristische Pruefung technischer Schutzrechte wie Patente und Gebrauchsmuster.",
      "Juristische Pruefung nichttechnischer Schutzrechte wie Marken und Design.",
      "Erstellung eines Schreibens aus der Rechtspraxis, etwa Anmeldung oder Bescheidserwiderung.",
      "Ausschliesslich freie Vortraege zu historischen Grundlagen des Patentrechts.",
    ],
    answers: [0, 1, 2],
    explanation:
      "§ 40 Abs. 1 PatAnwAPrV nennt fuer die schriftliche Pruefung drei typische Schwerpunkte: technische Schutzrechte, nichttechnische Schutzrechte und ein Schreiben aus der Rechtspraxis. Historische Vortraege sind kein dort genannter Klausurschwerpunkt.",
    sourceIds: ["patanw40"],
    levelNumber: 1,
    errorCategory: "Pruefungsstruktur",
    skillTags: ["pruefung", "patanwaprv"],
  }),
  makeMulti(sources, {
    id: "da-core-002",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Amtsjahr - Ausbildungsstationen",
    title: "Regulaere Ausbildungsstationen",
    prompt: "Welche Aussagen beschreiben die regulaeren Stationen der deutschen Patentanwaltsausbildung zutreffend?",
    options: [
      "Die praktische Ausbildung umfasst mindestens 26 Monate bei einem Patentanwalt oder in einer Patentabteilung.",
      "Zum Amtsjahr gehoeren Stationen beim DPMA und beim Bundespatentgericht.",
      "Nach bestandener Pruefung ist die Zulassung zur Patentanwaltschaft ein eigener berufsrechtlicher Schritt.",
      "§ 40 PatAnwAPrV verlangt eine zwingende Klausur-Reihenfolge DPMA vor BPatG.",
    ],
    answers: [0, 1, 2],
    explanation:
      "Die DPMA-Informationen beschreiben den Ausbildungsrahmen mit mindestens 26 Monaten Kanzlei/Patentabteilung sowie Stationen beim DPMA und beim BPatG. Die Frage ist bewusst nicht als zwingende Chronologie formuliert: Entscheidend ist die sichere Stationsabdeckung, nicht eine aus § 40 PatAnwAPrV abgeleitete Klausur-Reihenfolge.",
    sourceIds: ["dpmaAusbildung"],
    levelNumber: 1,
    errorCategory: "Amtsjahr",
    skillTags: ["amtsjahr", "ausbildung"],
  }),
  makeMulti(sources, {
    id: "da-core-003",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Amtsjahr - BPatG",
    title: "BPatG-Ausbildung: reale Schwerpunkte",
    prompt: "Welche Inhalte nennt das BPatG fuer die sechsmonatige Gerichtsausbildung?",
    options: [
      "Marken- und Designrecht sowie Unionsmarkenrecht.",
      "Patentrecht, Gebrauchsmusterrecht und Nichtigkeitsverfahren.",
      "Kostenfestsetzung und Uebungsklausuren.",
      "Nur technische Beschwerdesachen; Marken-/Designrecht und Kostenfestsetzung gehoeren laut BPatG nicht zur Ausbildung.",
    ],
    answers: [0, 1, 2],
    explanation:
      "Das BPatG beschreibt die Gerichtsausbildung mit Marken-Beschwerdesenat, Technischem Beschwerdesenat, moeglicher Teilnahme an Nichtigkeits-, Gebrauchsmuster- und juristischen Beschwerdesachen sowie Veranstaltungen zu Marken-/Designrecht, Patentrecht, Gebrauchsmusterrecht, Nichtigkeitsverfahren, Unionsmarkenrecht und Kostenfestsetzung.",
    sourceIds: ["bpatgAusbildung"],
    levelNumber: 2,
    errorCategory: "Amtsjahr",
    skillTags: ["amtsjahr", "bpatg", "verfahren"],
  }),
  makeSingle(sources, {
    id: "da-core-004",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Einspruch",
    title: "Nationaler Einspruch: Frist und Startpunkt",
    prompt: "Wann ist ein Einspruch gegen ein deutsches Patent nach § 59 PatG einzulegen?",
    options: [
      "Innerhalb von neun Monaten nach der Veroeffentlichung der Erteilung.",
      "Innerhalb von drei Monaten nach dem Anmeldetag.",
      "Jederzeit waehrend der gesamten Patentlaufzeit.",
      "Nur nach vorheriger Nichtigkeitsklage beim BPatG.",
    ],
    answer: 0,
    explanation:
      "§ 59 PatG sieht den Einspruch gegen das erteilte Patent innerhalb von neun Monaten nach der Veroeffentlichung der Erteilung vor. Danach ist der Einspruchsweg geschlossen; spaetere Angriffe laufen typischerweise ueber Nichtigkeit.",
    sourceIds: ["patg59"],
    levelNumber: 1,
    errorCategory: "Frist",
    skillTags: ["patg", "einspruch", "fristen"],
  }),
  makeSingle(sources, {
    id: "da-core-005",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Einspruch",
    title: "Einspruchsgruende: Verweis auf Widerrufsgruende",
    prompt: "Ein Einsprechender macht geltend, der patentierte Gegenstand sei nicht patentfaehig. Wie ist das im PatG einzuordnen?",
    options: [
      "Als Einspruchs-/Widerrufsgrund, weil § 59 PatG auf die Widerrufsgruende des § 21 PatG verweist.",
      "Als unzulaessig, weil Patentfaehigkeit nur im Verletzungsverfahren geprueft wird.",
      "Als reiner Kostenantrag ohne Einfluss auf das Patent.",
      "Als Grund nur, wenn der Patentinhaber vorher zugestimmt hat.",
    ],
    answer: 0,
    explanation:
      "Der Einspruch wird nach § 59 PatG eingelegt; die materiellen Widerrufsgruende stehen in § 21 PatG. § 21 Abs. 1 nennt insbesondere fehlende Patentfaehigkeit, mangelnde Ausfuehrbarkeit, widerrechtliche Entnahme und unzulaessige Erweiterung. § 59 PatG ist hier also der Verfahrensanker, § 21 PatG der materielle Gruende-Anker.",
    sourceIds: ["patg59", "patg21"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["patg", "einspruch", "bestandsverfahren"],
  }),
  makeOrdering(sources, {
    id: "da-core-006",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Einspruch/Beschraenkung",
    title: "Verfahrensbogen nach Einspruch",
    prompt: "Ordnen Sie den typischen Bestandsverfahrensbogen nach deutschem PatG.",
    orderItems: [
      "Patenterteilung wird veroeffentlicht.",
      "Dritter legt innerhalb der Einspruchsfrist Einspruch nach § 59 PatG ein.",
      "Patentabteilung prueft den Angriff und die Verteidigung des Patentinhabers.",
      "Patent wird widerrufen, unveraendert aufrechterhalten oder beschraenkt aufrechterhalten.",
    ],
    explanation:
      "Der Einspruch setzt an der Erteilung an. § 59 PatG regelt Einlegung und Verfahren; die materiellen Widerrufsgruende stehen in § 21 PatG. Auf einen zulaessigen Einspruch entscheidet die Patentabteilung nach § 61 PatG, ob und in welchem Umfang das Patent aufrechterhalten oder widerrufen wird. Das separate Beschraenkungs-/Widerrufsverfahren des Patentinhabers nach § 64 PatG ist davon zu trennen.",
    sourceIds: ["patg59", "patg21", "patg61"],
    levelNumber: 3,
    errorCategory: "Schema",
    skillTags: ["patg", "einspruch", "ordering"],
  }),
  makeSingle(sources, {
    id: "da-core-007",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Nichtigkeit",
    title: "Nichtigkeitsklage: zustaendiges Gericht",
    prompt: "Vor welchem Gericht wird die Nichtigkeit eines deutschen Patents in erster Instanz geltend gemacht?",
    options: [
      "Vor dem Bundespatentgericht.",
      "Vor dem DPMA-Pruefer, der die Anmeldung geprueft hat.",
      "Vor jedem Landgericht am Sitz des Verletzers.",
      "Vor dem Europäischen Patentamt.",
    ],
    answer: 0,
    explanation:
      "Die Nichtigkeitsklage nach § 81 PatG gehoert vor das Bundespatentgericht. Das ist der Kern des deutschen Trennungsprinzips: Verletzung vor den Zivilgerichten, Bestand/Nichtigkeit vor BPatG bzw. im Rechtsmittelzug BGH.",
    sourceIds: ["patg81"],
    levelNumber: 1,
    errorCategory: "Zustaendigkeit",
    skillTags: ["patg", "nichtigkeit", "bpatg"],
  }),
  makeSingle(sources, {
    id: "da-core-008",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Pruefungsverfahren",
    title: "Pruefungsantrag",
    prompt: "Welche Funktion hat der Pruefungsantrag nach § 44 PatG?",
    options: [
      "Er loest die sachliche Pruefung der Patentanmeldung aus.",
      "Er ersetzt die Offenbarung der Erfindung.",
      "Er verlaengert die Patentlaufzeit.",
      "Er ist nur im Einspruchsverfahren erforderlich.",
    ],
    answer: 0,
    explanation:
      "§ 44 PatG verankert den Pruefungsantrag: Ohne ihn bleibt die Anmeldung nicht in der sachlichen Pruefung. Fuer Bescheidserwiderungen ist wichtig, den Verfahrensstand Anmeldung/Pruefung/Erteilung sauber zu trennen.",
    sourceIds: ["patg44"],
    levelNumber: 1,
    errorCategory: "Verfahren",
    skillTags: ["patg", "erteilungsverfahren"],
  }),
  makeSingle(sources, {
    id: "da-core-009",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Wiedereinsetzung",
    title: "Wiedereinsetzung: Leitidee",
    prompt: "Welche Aussage trifft die Wiedereinsetzung nach § 123 PatG am besten?",
    options: [
      "Sie kann unter den gesetzlichen Voraussetzungen helfen, wenn eine Frist ohne Verschulden versaeumt wurde.",
      "Sie heilt jede beliebige Fristversaeumung automatisch.",
      "Sie steht nur dem Einsprechenden offen, nie dem Anmelder.",
      "Sie ersetzt die Zahlung von Jahresgebuehren dauerhaft.",
    ],
    answer: 0,
    explanation:
      "§ 123 PatG ist die zentrale Korrekturvorschrift fuer schuldlos versaeumte Fristen. Sie ist kein Automatismus: Die versaeumte Handlung und die Wiedereinsetzungsanforderungen muessen rechtzeitig und substantiiert nachgeholt bzw. dargelegt werden.",
    sourceIds: ["patg123"],
    levelNumber: 2,
    errorCategory: "Frist",
    skillTags: ["patg", "wiedereinsetzung", "fristen"],
  }),
  makeSingle(sources, {
    id: "da-core-010",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Zwangslizenz",
    title: "Zwangslizenz: Ausnahmeinstrument",
    prompt: "Was ist die Zwangslizenz nach § 24 PatG ihrem Grundcharakter nach?",
    options: [
      "Ein Ausnahmeinstrument, mit dem bei gesetzlichen Voraussetzungen eine Benutzungserlaubnis gegen den Willen des Patentinhabers erteilt werden kann.",
      "Ein automatisches Recht jedes Wettbewerbers nach drei Jahren Patentlaufzeit.",
      "Ein Einwand, der nur im Markenrecht vorkommt.",
      "Eine Moeglichkeit des Patentinhabers, sein Patent ohne Registereintrag zu verlaengern.",
    ],
    answer: 0,
    explanation:
      "§ 24 PatG regelt die Zwangslizenz als enges Ausnahmeinstrument. Pruefungsrelevant ist die Abgrenzung zur freiwilligen Lizenz: Die Zwangslizenz greift nicht aus blosser wirtschaftlicher Zweckmaessigkeit, sondern nur unter den gesetzlichen Voraussetzungen.",
    sourceIds: ["patg24"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["patg", "zwangslizenz"],
  }),
  makeSingle(sources, {
    id: "da-core-011",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PatG - Vorbenutzung",
    title: "Vorbenutzungsrecht: Betriebsbezogenheit",
    prompt: "Welche Aussage zum Vorbenutzungsrecht nach § 12 PatG ist richtig?",
    options: [
      "Es erlaubt die Benutzung fuer die Beduerfnisse des eigenen Betriebs, wenn die gesetzlichen Voraussetzungen vorliegen.",
      "Es vernichtet das Patent insgesamt.",
      "Es erlaubt jedem Dritten die freie Benutzung nach Veroeffentlichung der Anmeldung.",
      "Es entsteht erst nach erfolgreicher Nichtigkeitsklage.",
    ],
    answer: 0,
    explanation:
      "§ 12 PatG schuetzt den qualifizierten Vorbenutzer betriebsbezogen. Das Patent bleibt bestehen; der Vorbenutzer erhaelt nur eine eigene Benutzungsbefugnis fuer den geschuetzten betrieblichen Umfang.",
    sourceIds: ["patg12"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["patg", "vorbenutzung"],
  }),
  makeSingle(sources, {
    id: "da-core-012",
    pathId,
    reviewStatus: "beta-ready",
    topic: "PCT / Euro-PCT",
    title: "Euro-PCT: 31-Monats-Eintritt",
    prompt: "Welche Frist ist fuer den Eintritt einer internationalen Anmeldung in die europaeische Phase vor dem EPA typischerweise zentral?",
    options: ["31 Monate nach Anmelde- oder Prioritaetstag.", "9 Monate nach Erteilung.", "6 Wochen nach Recherchebericht.", "20 Jahre nach Anmeldetag."],
    answer: 0,
    explanation:
      "Fuer Euro-PCT-Anmeldungen ist R. 159 EPUE zentral: Die fuer den Eintritt in die europaeische Phase erforderlichen Handlungen muessen grundsaetzlich binnen 31 Monaten ab Anmelde- oder Prioritaetstag vorgenommen werden. Art. 22 PCT bildet den internationalen Rahmen fuer den Eintritt in nationale/regionale Phasen.",
    sourceIds: ["epc159", "pct22"],
    levelNumber: 1,
    errorCategory: "Frist",
    skillTags: ["pct", "epu", "fristen"],
  }),
  makeSingle(sources, {
    id: "da-core-013",
    pathId,
    reviewStatus: "beta-ready",
    topic: "EPUE national",
    title: "Wirkung europaeischer Patente in Deutschland",
    prompt: "Welche Aussage beschreibt die Wirkung eines europaeischen Patents in Deutschland zutreffend?",
    options: [
      "Nach Art. 64 EPUE verleiht ein europaeisches Patent in jedem benannten Vertragsstaat grundsaetzlich dieselben Rechte wie ein nationales Patent.",
      "Ein europaeisches Patent wirkt in Deutschland nur nach nochmaliger DPMA-Sachpruefung.",
      "Ein europaeisches Patent hat in Deutschland keine Verletzungswirkung.",
      "Ein europaeisches Patent ist immer automatisch ein Einheitspatent.",
    ],
    answer: 0,
    explanation:
      "Art. 64 EPUE ordnet an, dass das europaeische Patent in den benannten Vertragsstaaten grundsaetzlich dieselben Rechte verleiht wie ein nationales Patent. Das Einheitspatent ist davon zu trennen: Es ist eine besondere einheitliche Wirkung, nicht die automatische Folge jeder EP-Erteilung.",
    sourceIds: ["epc64", "intpat"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["epu", "patg", "international"],
  }),
  makeSingle(sources, {
    id: "da-core-014",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Einheitspatent / UPC",
    title: "UPC: Grundfunktion",
    prompt: "Welche Grundfunktion hat das Einheitliche Patentgericht (UPC/EPG) im neuen europaeischen Patentsystem?",
    options: [
      "Es buendelt bestimmte Verletzungs- und Bestandsstreitigkeiten zu europaeischen Patenten mit einheitlicher bzw. nicht opt-out-betroffener Wirkung.",
      "Es ersetzt das Europaeische Patentamt bei der Pruefung aller Patentanmeldungen.",
      "Es entscheidet ueber deutsche Markenwidersprueche.",
      "Es ist nur fuer PCT-Anmeldetage zustaendig.",
    ],
    answer: 0,
    explanation:
      "Das UPC/EPG ist ein Gerichtssystem fuer bestimmte Verletzungs- und Bestandsstreitigkeiten im europaeischen Patentverbund. Es ersetzt nicht die EPA-Erteilungspruefung und ist nicht fuer Markenwidersprueche oder PCT-Formalien zustaendig.",
    sourceIds: ["upc"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["upc", "einheitspatent", "international"],
  }),
  makeMulti(sources, {
    id: "da-core-015",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Gebrauchsmusterrecht",
    title: "Gebrauchsmuster: Schutzgegenstand und Ausschluesse",
    prompt: "Welche Aussagen zum Gebrauchsmusterrecht treffen zu?",
    options: [
      "§ 1 GebrMG schuetzt technische Erfindungen, die neu sind, auf erfinderischem Schritt beruhen und gewerblich anwendbar sind.",
      "§ 2 GebrMG schliesst unter anderem Verfahren vom Gebrauchsmusterschutz aus.",
      "Ein Gebrauchsmuster ersetzt die Patentanmeldung immer vollstaendig.",
      "Der Gebrauchsmusterschutz ist identisch mit Markenschutz.",
    ],
    answers: [0, 1],
    explanation:
      "§ 1 GebrMG nennt die materiellen Schutzvoraussetzungen. § 2 GebrMG enthaelt Ausschluesse, insbesondere Verfahren. Daher ist das Gebrauchsmuster kein Patent- oder Markenersatz, sondern ein eigenstaendiges technisches Schutzrecht mit anderen Grenzen.",
    sourceIds: ["gebrmg1", "gebrmg2"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["gebrauchsmuster", "schutzfaehigkeit"],
  }),
  makeSingle(sources, {
    id: "da-core-016",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Gebrauchsmusterrecht",
    title: "Stand der Technik im GebrMG",
    prompt: "Was ist eine zentrale Besonderheit des Stands der Technik im Gebrauchsmusterrecht?",
    options: [
      "Er ist gegenueber dem Patentrecht enger: insbesondere zaehlen oeffentliche Benutzungen nur im Inland.",
      "Er umfasst niemals schriftliche Beschreibungen.",
      "Er ist vollstaendig identisch mit Art. 54(2) EPUE.",
      "Er wird erst im Verletzungsprozess definiert.",
    ],
    answer: 0,
    explanation:
      "§ 3 GebrMG definiert den Stand der Technik anders als das Patentrecht. Besonders pruefungstraechtig: schriftliche Beschreibungen zaehlen, oeffentliche Benutzungen aber nur, soweit sie im Inland erfolgt sind. Diese Abweichung macht GebrMG-Faelle klausuranfaellig.",
    sourceIds: ["gebrmg3"],
    levelNumber: 3,
    errorCategory: "Abgrenzung",
    skillTags: ["gebrauchsmuster", "neuheit"],
  }),
  makeSingle(sources, {
    id: "da-core-017",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Gebrauchsmusterrecht",
    title: "Abzweigung",
    prompt: "Welche Funktion hat die Abzweigung nach § 5 GebrMG?",
    options: [
      "Aus einer Patentanmeldung kann unter gesetzlichen Voraussetzungen ein Gebrauchsmuster mit dem frueheren Anmeldetag abgezweigt werden.",
      "Eine Marke kann in ein Patent umgewandelt werden.",
      "Ein Gebrauchsmuster wird automatisch nach zehn Jahren zum Patent.",
      "Ein Design kann ohne Anmeldung zum Gebrauchsmuster werden.",
    ],
    answer: 0,
    explanation:
      "§ 5 GebrMG erlaubt die Abzweigung eines Gebrauchsmusters aus einer frueheren Patentanmeldung. Das ist strategisch wichtig, weil das Gebrauchsmuster schneller eingetragen wird und unter Umstaenden frueher durchsetzbar ist.",
    sourceIds: ["gebrmg5"],
    levelNumber: 2,
    errorCategory: "Verfahren",
    skillTags: ["gebrauchsmuster", "abzweigung"],
  }),
  makeSingle(sources, {
    id: "da-core-018",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Gebrauchsmusterrecht",
    title: "Loeschung",
    prompt: "Welche Aussage zum Gebrauchsmusterloeschungsverfahren ist richtig?",
    options: [
      "Die Loeschung kann insbesondere auf fehlende Schutzfaehigkeit gestuetzt werden.",
      "Eine Loeschung ist ausgeschlossen, weil Gebrauchsmuster nie geprueft werden.",
      "Nur der Inhaber darf Loeschung beantragen.",
      "Das Loeschungsverfahren ist ein Markenwiderspruch.",
    ],
    answer: 0,
    explanation:
      "§ 15 GebrMG nennt Loeschungsgruende, darunter fehlende Schutzfaehigkeit. Dass das Gebrauchsmuster ohne materielle Pruefung eingetragen wird, macht das Loeschungsverfahren gerade praktisch wichtig.",
    sourceIds: ["gebrmg15"],
    levelNumber: 2,
    errorCategory: "Bestandsverfahren",
    skillTags: ["gebrauchsmuster", "loeschung"],
  }),
  makeMulti(sources, {
    id: "da-core-019",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Designrecht",
    title: "Designschutz: Neuheit und Eigenart",
    prompt: "Welche Aussagen zu § 2 DesignG treffen zu?",
    options: [
      "Ein Design wird geschuetzt, wenn es neu ist und Eigenart hat.",
      "Neuheit und Eigenart sind getrennte Schutzvoraussetzungen.",
      "Technische Erfindungshoehe ist die zentrale Designvoraussetzung.",
      "Designschutz setzt immer Markenbenutzung voraus.",
    ],
    answers: [0, 1],
    explanation:
      "§ 2 DesignG knuepft den Designschutz an Neuheit und Eigenart. Es geht nicht um technische Erfindungshoehe wie im Patent- oder Gebrauchsmusterrecht und auch nicht um Herkunftsfunktion wie im Markenrecht.",
    sourceIds: ["design2"],
    levelNumber: 1,
    errorCategory: "Definition",
    skillTags: ["designrecht", "schutzfaehigkeit"],
  }),
  makeSingle(sources, {
    id: "da-core-020",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Designrecht",
    title: "Neuheit beim Design",
    prompt: "Wann fehlt einem Design nach § 3 DesignG die Neuheit?",
    options: [
      "Wenn vor dem Anmeldetag ein identisches Design offenbart wurde; unwesentliche Einzelheiten bleiben ausser Betracht.",
      "Nur wenn ein identisches Patent erteilt wurde.",
      "Nur wenn eine Marke mit gleichem Namen besteht.",
      "Immer, wenn das Produkt technisch funktioniert.",
    ],
    answer: 0,
    explanation:
      "§ 3 DesignG definiert Neuheit ueber die Offenbarung eines identischen Designs; Designs gelten auch dann als identisch, wenn sich ihre Merkmale nur in unwesentlichen Einzelheiten unterscheiden. Das ist ein anderer Test als Patentneuheit.",
    sourceIds: ["design3"],
    levelNumber: 2,
    errorCategory: "Subsumtion",
    skillTags: ["designrecht", "neuheit"],
  }),
  makeCloze(sources, {
    id: "da-core-021",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Designrecht",
    title: "Maximale Schutzdauer",
    prompt: "Ein eingetragenes Design kann nach § 27 DesignG insgesamt bis zu ___ Jahre aufrechterhalten werden.",
    options: ["10", "15", "20", "25"],
    answer: 3,
    explanation:
      "§ 27 DesignG erlaubt eine maximale Schutzdauer von 25 Jahren, typischerweise in Fuenfjahresabschnitten. Diese Frist ist ein klassischer Abgrenzungsanker gegen Patentlaufzeit und Markenverlaengerung.",
    sourceIds: ["design27"],
    levelNumber: 1,
    errorCategory: "Frist",
    skillTags: ["designrecht", "fristen"],
  }),
  makeSingle(sources, {
    id: "da-core-022",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Designrecht - GGV",
    title: "Gemeinschaftsgeschmacksmuster",
    prompt: "Welche Aussage zum Gemeinschaftsgeschmacksmuster nach der GGV ist richtig?",
    options: [
      "Es ist ein unionsweites Designschutzinstrument neben dem nationalen Designrecht.",
      "Es schuetzt technische Lehren wie ein Patent.",
      "Es ersetzt das Markenrecht fuer Herkunftshinweise.",
      "Es kann nur durch das DPMA geprueft werden.",
    ],
    answer: 0,
    explanation:
      "Die VO (EG) Nr. 6/2002 schafft ein unionsweites Designschutzsystem. Pruefungsrelevant ist die Abgrenzung: Design schuetzt Erscheinungsform, nicht technische Lehre und nicht Herkunftsfunktion.",
    sourceIds: ["ggv"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["designrecht", "eu-recht"],
  }),
  makeSingle(sources, {
    id: "da-core-023",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Diensterfindung",
    prompt: "Was ist eine Diensterfindung im Sinne von § 4 ArbnErfG im Kern?",
    options: [
      "Eine Erfindung, die aus der dem Arbeitnehmer obliegenden Taetigkeit entstanden ist oder massgeblich auf Erfahrungen/Arbeiten des Betriebs beruht.",
      "Jede private Idee eines Arbeitnehmers ausserhalb des technischen Gebiets.",
      "Nur eine bereits erteilte Patentanmeldung.",
      "Eine Marke, die ein Arbeitnehmer waehrend der Arbeitszeit benutzt.",
    ],
    answer: 0,
    explanation:
      "§ 4 ArbnErfG unterscheidet Diensterfindungen und freie Erfindungen. Diensterfindungen stehen in einem dienstlichen Zusammenhang; gerade diese Einordnung loest Melde-, Inanspruchnahme- und Verguetungsfragen aus.",
    sourceIds: ["arb4"],
    levelNumber: 1,
    errorCategory: "Definition",
    skillTags: ["arbeitnehmererfindung", "diensterfindung"],
  }),
  makeSingle(sources, {
    id: "da-core-024",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Erfindungsmeldung",
    prompt: "Welche Rolle spielt die ordnungsgemaesse Erfindungsmeldung nach § 5 ArbnErfG?",
    options: [
      "Sie setzt den Arbeitgeber in die Lage, ueber Inanspruchnahme oder Freigabe zu entscheiden.",
      "Sie ersetzt die Patentansprueche.",
      "Sie fuehrt automatisch zur Loeschung aller Veroeffentlichungen.",
      "Sie ist nur bei freien Erfindungen erforderlich.",
    ],
    answer: 0,
    explanation:
      "§ 5 ArbnErfG verlangt die Meldung der Diensterfindung. Sie ist der praktische Startpunkt: Erst eine ordnungsgemaesse Meldung gibt dem Arbeitgeber eine belastbare Entscheidungsgrundlage fuer Inanspruchnahme oder Freigabe.",
    sourceIds: ["arb5"],
    levelNumber: 2,
    errorCategory: "Verfahren",
    skillTags: ["arbeitnehmererfindung", "meldung"],
  }),
  makeCloze(sources, {
    id: "da-core-025",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Viermonatsmechanik",
    prompt: "Die Inanspruchnahme einer Diensterfindung gilt nach § 6 ArbnErfG als erklaert, wenn der Arbeitgeber die Erfindung nicht bis zum Ablauf von ___ Monaten nach Eingang der ordnungsgemaessen Meldung freigibt.",
    options: ["zwei", "drei", "vier", "neun"],
    answer: 2,
    explanation:
      "§ 6 ArbnErfG arbeitet mit der Viermonatsmechanik: Gibt der Arbeitgeber die ordnungsgemaess gemeldete Diensterfindung nicht rechtzeitig frei, gilt die Inanspruchnahme als erklaert. Das ist ein hoch pruefungstraechtiger Fristenanker.",
    sourceIds: ["arb6"],
    levelNumber: 2,
    errorCategory: "Frist",
    skillTags: ["arbeitnehmererfindung", "fristen"],
  }),
  makeSingle(sources, {
    id: "da-core-026",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Verguetung",
    prompt: "Welche Folge hat die berechtigte Inanspruchnahme einer Diensterfindung fuer den Arbeitnehmer?",
    options: [
      "Er hat dem Grunde nach einen Anspruch auf angemessene Verguetung nach § 9 ArbnErfG.",
      "Er verliert jeden Anspruch auf Gegenleistung.",
      "Er wird automatisch Mitinhaber jedes Patents.",
      "Er muss die Anmeldungskosten allein tragen.",
    ],
    answer: 0,
    explanation:
      "§ 9 ArbnErfG ordnet fuer die in Anspruch genommene Diensterfindung einen Anspruch des Arbeitnehmers auf angemessene Verguetung an. Die genaue Hoehe ist ein eigener Berechnungskomplex, aber der Anspruch dem Grunde nach ist Pflichtwissen.",
    sourceIds: ["arb9"],
    levelNumber: 1,
    errorCategory: "Rechtsfolge",
    skillTags: ["arbeitnehmererfindung", "verguetung"],
  }),
  makeSingle(sources, {
    id: "da-core-027",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Freie Erfindung",
    prompt: "Welche Aussage zur freien Erfindung nach § 18 ArbnErfG ist richtig?",
    options: [
      "Auch freie Erfindungen koennen unter den gesetzlichen Voraussetzungen mitteilungspflichtig sein.",
      "Freie Erfindungen sind immer Eigentum des Arbeitgebers.",
      "Freie Erfindungen koennen nie patentfaehig sein.",
      "Freie Erfindungen gibt es nur im Markenrecht.",
    ],
    answer: 0,
    explanation:
      "§ 18 ArbnErfG regelt Mitteilungspflichten fuer freie Erfindungen. Das ist die typische Falle: Frei bedeutet nicht automatisch kommunikationsfrei; der Arbeitgeber soll pruefen koennen, ob die Einordnung als frei zutrifft.",
    sourceIds: ["arb18"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["arbeitnehmererfindung", "freie-erfindung"],
  }),
  makeSingle(sources, {
    id: "da-core-028",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Arbeitnehmererfindungsrecht",
    title: "Schiedsstelle",
    prompt: "Welche Funktion hat die Schiedsstelle im Arbeitnehmererfindungsrecht?",
    options: [
      "Sie dient der Streitbeilegung, insbesondere bei Verguetungs- und ArbnErfG-Streitigkeiten.",
      "Sie erteilt Patente anstelle des DPMA.",
      "Sie entscheidet Markenwidersprueche als letzte Instanz.",
      "Sie fuehrt die europaeische Eignungspruefung durch.",
    ],
    answer: 0,
    explanation:
      "§ 28 ArbnErfG verankert die Schiedsstelle. In der Praxis ist sie wichtig, weil Arbeitnehmererfindungsstreitigkeiten haeufig zuerst aussergerichtlich bzw. vor der Schiedsstelle strukturiert werden.",
    sourceIds: ["arb28"],
    levelNumber: 2,
    errorCategory: "Verfahren",
    skillTags: ["arbeitnehmererfindung", "schiedsstelle"],
  }),
  makeFlashcard(sources, {
    id: "da-core-029",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Sortenschutz / Halbleiterschutz",
    title: "Randgebiete in § 40 PatAnwAPrV",
    prompt: "Warum gehoeren Sortenschutz und Halbleiterschutz trotz Randstellung in die Ausbildungsabdeckung?",
    explanation:
      "§ 40 Abs. 2 Nr. 5 PatAnwAPrV nennt Sortenschutzrecht ausdruecklich als muendliches Pruefungsgebiet. § 3 PAO zaehlt ausserdem Topographien und Sortenschutz zu den gewerblichen Schutzrechten im patentanwaltlichen Taetigkeitsbereich. Deshalb braucht die App wenigstens sichere Grundabdeckung dieser Randgebiete.",
    sourceIds: ["patanw40", "sortschg", "halblschg", "pao3"],
    levelNumber: 1,
    errorCategory: "Pruefungsstruktur",
    skillTags: ["sortenschutz", "halbleiterschutz", "berufsrecht"],
  }),
  makeSingle(sources, {
    id: "da-core-030",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Markenrecht vertieft",
    title: "Widerspruch",
    prompt: "Welche Funktion hat der Widerspruch nach § 42 MarkenG?",
    options: [
      "Er ist ein registerrechtlicher Angriff auf eine juengere Marke aus relativen Rechten.",
      "Er ist ein Verletzungsurteil des Landgerichts.",
      "Er ersetzt die Benutzungsschonfrist.",
      "Er verlaengert automatisch die Schutzdauer einer Marke.",
    ],
    answer: 0,
    explanation:
      "§ 42 MarkenG ermoeglicht den Widerspruch gegen eine eingetragene Marke, insbesondere gestuetzt auf aeltere Rechte. Das ist vom Verletzungsprozess und von Verfalls-/Nichtigkeitsverfahren zu trennen.",
    sourceIds: ["marken42"],
    levelNumber: 2,
    errorCategory: "Verfahren",
    skillTags: ["markenrecht", "widerspruch"],
  }),
  makeSingle(sources, {
    id: "da-core-031",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Markenrecht vertieft",
    title: "Verfall wegen Nichtbenutzung",
    prompt: "Was ist der Kern des Verfalls wegen Nichtbenutzung im Markenrecht?",
    options: [
      "Eine Marke kann verfallen, wenn sie nach Ablauf der Schonfrist nicht rechtserhaltend benutzt wird.",
      "Eine Marke verfaellt immer nach fuenf Jahren ohne Verlaengerungsmoeglichkeit.",
      "Nichtbenutzung betrifft nur Patente.",
      "Verfall setzt zwingend boesglaeubige Anmeldung voraus.",
    ],
    answer: 0,
    explanation:
      "§ 49 MarkenG verankert den Verfall, unter anderem bei fehlender rechtserhaltender Benutzung. Das ist von Nichtigkeit wegen Schutzhindernissen oder aelteren Rechten zu unterscheiden.",
    sourceIds: ["marken49"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["markenrecht", "verfall", "benutzung"],
  }),
  makeSingle(sources, {
    id: "da-core-032",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Markenrecht international",
    title: "IR-Marke / Madrider System",
    prompt: "Welche Rolle spielt das Madrider System fuer Marken?",
    options: [
      "Es ermoeglicht eine internationale Registrierung/Schutzerstreckung ueber ein zentrales System.",
      "Es erteilt europaeische Patente.",
      "Es ist ein deutsches Nichtigkeitsgericht.",
      "Es ersetzt die Benutzung einer Marke im Inland.",
    ],
    answer: 0,
    explanation:
      "Das Madrider System der WIPO organisiert internationale Markenregistrierungen und Schutzerstreckungen. Fuer die Ausbildung ist wichtig: Es ist ein Verfahrensrahmen fuer Marken, kein Patenterteilungs- oder Verletzungsgericht.",
    sourceIds: ["madrid"],
    levelNumber: 1,
    errorCategory: "International",
    skillTags: ["markenrecht", "madrid", "international"],
  }),
  makeSingle(sources, {
    id: "da-core-033",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Geografische Angaben",
    title: "Geografische Angaben als Schutzbereich",
    prompt: "Warum gehoeren geografische Angaben inzwischen in die Orientierungsabdeckung der Ausbildung?",
    options: [
      "§ 3 PAO erfasst auch Agrargeoschutz in patentanwaltlichen Angelegenheiten; die Schutzart beruehrt Marken-/Kennzeichenpraxis.",
      "Weil geografische Angaben immer technische Erfindungen sind.",
      "Weil sie Gebrauchsmuster automatisch nichtig machen.",
      "Weil sie die ZPO ersetzen.",
    ],
    answer: 0,
    explanation:
      "§ 3 PAO nennt im Taetigkeitsbereich des Patentanwalts inzwischen auch Agrargeoschutz. Fuer die App genuegt ein stabiler Orientierungsanker: geografische Angaben sind Kennzeichen-/Herkunftsschutz, nicht Patent- oder Gebrauchsmusterschutz.",
    sourceIds: ["pao3", "agrar"],
    levelNumber: 2,
    errorCategory: "Abgrenzung",
    skillTags: ["markenrecht", "geografische-angaben", "berufsrecht"],
  }),
  makeSingle(sources, {
    id: "da-core-034",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Berufsrecht - PAO",
    title: "Beratungs- und Vertretungsbefugnis",
    prompt: "Welche Aussage beschreibt § 3 PAO zutreffend?",
    options: [
      "Der Patentanwalt leistet unabhaengige Beratung und Vertretung in patentanwaltlichen Angelegenheiten, insbesondere zu gewerblichen Schutzrechten.",
      "Der Patentanwalt darf ausschliesslich technische Gutachten ohne Rechtsbezug erstellen.",
      "Der Patentanwalt ist nur vor Strafgerichten vertretungsbefugt.",
      "Der Patentanwalt darf niemals vor dem BPatG auftreten.",
    ],
    answer: 0,
    explanation:
      "§ 3 PAO beschreibt die berufliche Aufgabe des Patentanwalts: unabhaengige Beratung und Vertretung, insbesondere bei Erlangung, Aufrechterhaltung, Verteidigung und Anfechtung gewerblicher Schutzrechte sowie Vertretung vor DPMA/BPatG und in bestimmten BGH-Verfahren.",
    sourceIds: ["pao3"],
    levelNumber: 1,
    errorCategory: "Berufsrecht",
    skillTags: ["pao", "berufsrecht"],
  }),
  makeSingle(sources, {
    id: "da-core-035",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Berufsrecht - PAO",
    title: "Zugang zum Beruf",
    prompt: "Welche Norm ist ein zentraler Anker fuer den Zugang zur Patentanwaltschaft?",
    options: ["§ 5 PAO.", "§ 14 PatG.", "Art. 54 EPUE.", "§ 890 ZPO."],
    answer: 0,
    explanation:
      "§ 5 PAO regelt den Zugang zum Beruf des Patentanwalts. In der Pruefung ist die Trennung wichtig: PAO/PatAnwAPrV betreffen Beruf und Ausbildung; PatG/EPUE betreffen Schutzrechte und Verfahren.",
    sourceIds: ["pao5"],
    levelNumber: 1,
    errorCategory: "Berufsrecht",
    skillTags: ["pao", "zulassung"],
  }),
  makeSingle(sources, {
    id: "da-core-036",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Berufsrecht - PAO",
    title: "Kanzleipflicht",
    prompt: "Welche Grundpflicht folgt aus § 26 PAO?",
    options: [
      "Der Patentanwalt muss im Geltungsbereich des Gesetzes eine Kanzlei einrichten und unterhalten.",
      "Der Patentanwalt muss jedes Patent selbst anmelden.",
      "Der Patentanwalt darf keine Zweigstelle anzeigen.",
      "Der Patentanwalt muss beim EPA angestellt sein.",
    ],
    answer: 0,
    explanation:
      "§ 26 PAO regelt die Kanzlei. Die Norm ist berufsrechtlich wichtig, weil sie die organisatorische Praesenz des Patentanwalts im Geltungsbereich der PAO verankert.",
    sourceIds: ["pao26"],
    levelNumber: 1,
    errorCategory: "Berufsrecht",
    skillTags: ["pao", "kanzlei"],
  }),
  makeSingle(sources, {
    id: "da-core-037",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Berufsrecht - PAO",
    title: "Verschwiegenheit",
    prompt: "Welche Aussage zu § 39a PAO ist richtig?",
    options: [
      "Die Grundpflichten erfassen die Verschwiegenheit; auch beschaeftigte Personen sind zur Verschwiegenheit zu verpflichten.",
      "Verschwiegenheit gilt nur in Strafsachen.",
      "Verschwiegenheit endet automatisch mit jeder Patentanmeldung.",
      "Beschaeftigte Personen duerfen nie in Mandate eingebunden werden.",
    ],
    answer: 0,
    explanation:
      "§ 39a PAO verankert Grundpflichten und die Verschwiegenheit. Praktisch wichtig ist auch die Pflicht, beschaeftigte Personen in Textform zur Verschwiegenheit zu verpflichten und ueber strafrechtliche Folgen zu belehren.",
    sourceIds: ["pao39a"],
    levelNumber: 2,
    errorCategory: "Berufsrecht",
    skillTags: ["pao", "verschwiegenheit"],
  }),
  makeSingle(sources, {
    id: "da-core-038",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Berufsrecht - Kammer",
    title: "Patentanwaltskammer",
    prompt: "Welche Funktion hat die Patentanwaltskammer im berufsrechtlichen System?",
    options: [
      "Sie ist die berufsstaendische Selbstverwaltung mit Aufgaben nach der PAO.",
      "Sie erteilt europaeische Patente.",
      "Sie entscheidet als Verletzungsgericht.",
      "Sie ersetzt das DPMA im Eintragungsverfahren fuer Marken.",
    ],
    answer: 0,
    explanation:
      "§ 54 PAO beschreibt Aufgaben der Patentanwaltskammer. Die Kammer ist berufsrechtliche Selbstverwaltung, nicht Erteilungsbehoerde fuer Patente/Marken und kein Verletzungsgericht.",
    sourceIds: ["pao54"],
    levelNumber: 1,
    errorCategory: "Berufsrecht",
    skillTags: ["pao", "kammer"],
  }),
  makeOrdering(sources, {
    id: "da-core-039",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Verfahrensrecht",
    title: "Einstweiliger Rechtsschutz in IP-Sachen",
    prompt: "Ordnen Sie die Pruefung einer einstweiligen Verfuegung in einer IP-Verletzungssache.",
    orderItems: [
      "Verfuegungsanspruch pruefen: materieller Anspruch, z.B. Unterlassung.",
      "Verfuegungsgrund pruefen: Eilbeduerftigkeit und drohende Vereitelung/Erschwerung.",
      "Glaubhaftmachung und Interessenabwaegung einordnen.",
      "Vollziehung und Ordnungsmittel im Blick behalten.",
    ],
    explanation:
      "§§ 935 ff. ZPO strukturieren den einstweiligen Rechtsschutz. In IP-Sachen ist die schnelle Durchsetzung praktisch zentral; § 890 ZPO wird spaeter fuer die Durchsetzung von Unterlassungstiteln relevant.",
    sourceIds: ["zpo935", "zpo890"],
    levelNumber: 3,
    errorCategory: "Schema",
    skillTags: ["verfahren", "zpo", "verletzung"],
  }),
  makeCloze(sources, {
    id: "da-core-040",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Verfahrensrecht",
    title: "Ordnungsgeld",
    prompt: "Zur Durchsetzung eines Unterlassungstitels kann nach § 890 ZPO ein Ordnungsgeld bis zu ___ Euro festgesetzt werden.",
    options: ["25.000", "100.000", "250.000", "500.000"],
    answer: 2,
    explanation:
      "§ 890 ZPO nennt als Ordnungsmittel bei Zuwiderhandlung gegen Unterlassungs- oder Duldungspflichten ein Ordnungsgeld bis zu 250.000 Euro oder Ordnungshaft. Das ist ein haeufiger Praxisanker in Verletzungssachen.",
    sourceIds: ["zpo890"],
    levelNumber: 1,
    errorCategory: "Rechtsfolge",
    skillTags: ["verfahren", "vollstreckung", "zpo"],
  }),
  makeSingle(sources, {
    id: "da-core-041",
    pathId,
    reviewStatus: "beta-ready",
    topic: "UWG / ergaenzender Leistungsschutz",
    title: "UWG neben Sonderschutzrechten",
    prompt: "Welche Aussage zum ergaenzenden wettbewerbsrechtlichen Leistungsschutz ist als Grundsatz richtig?",
    options: [
      "UWG-Schutz kann neben IP-Sonderschutzrechten relevant sein, darf aber deren Wertungen und Schutzfristen nicht beliebig unterlaufen.",
      "UWG-Schutz verlaengert jedes abgelaufene Patent automatisch.",
      "UWG-Schutz ersetzt die Schutzvoraussetzungen von Marken und Designs.",
      "UWG-Schutz ist nur im Strafrecht relevant.",
    ],
    answer: 0,
    explanation:
      "§ 4 UWG enthaelt Tatbestaende unlauterer geschäftlicher Handlungen. In IP-Konstellationen ist der ergaenzende Leistungsschutz wichtig, aber kein Freifahrtschein zur Umgehung abgelaufener oder nicht erreichter Sonderschutzrechte.",
    sourceIds: ["uwg4"],
    levelNumber: 3,
    errorCategory: "Abgrenzung",
    skillTags: ["uwg", "wettbewerbsrecht", "ip"],
  }),
  makeMulti(sources, {
    id: "da-core-042",
    pathId,
    reviewStatus: "beta-ready",
    topic: "Internationales IP-Recht",
    title: "PVUE und TRIPS als internationale Grundanker",
    prompt: "Welche Aussagen zu PVUE/TRIPS sind fuer die Ausbildung als Orientierung richtig?",
    options: [
      "Die PVUE ist ein Kernanker fuer Prioritaet und Inlaenderbehandlung im gewerblichen Rechtsschutz.",
      "TRIPS setzt internationale Mindeststandards fuer Immaterialgueterrechte im WTO-Rahmen.",
      "PVUE und TRIPS ersetzen nationale Patent- und Markengesetze vollstaendig.",
      "PVUE ist ein deutsches Zwangsvollstreckungsgesetz.",
    ],
    answers: [0, 1],
    explanation:
      "Die PVUE ist besonders fuer Prioritaet und Inlaenderbehandlung zentral; TRIPS setzt Mindeststandards im WTO-System. Beide ersetzen nationale oder europaeische Schutzrechtsordnungen nicht, sondern rahmen sie international ein.",
    sourceIds: ["pvue", "trips"],
    levelNumber: 2,
    errorCategory: "International",
    skillTags: ["international", "pvue", "trips"],
  }),
];
